"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatStateServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class ChatStateService extends client_1.RWSService {
    constructor() {
        super(...arguments);
        this.selectedModel = null;
        this.selectedAIProvider = null;
        this.selectedAvatar = null;
        this.knowledge = [];
        this.fullKnowledgeIds = [];
        this.injectedMessages = [];
        this.webSearchEnabled = false;
        this.deepSearchEnabled = false;
        this.fullscan = false;
    }
    /**
     * Set conversation data without affecting current model selection
     */
    setConversationData(conversation) {
        var _a, _b;
        if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] Setting conversation data:', conversation);
            console.log('[ChatStateService] Current avatar before update:', this.selectedAvatar);
        }
        // Preserve current avatar selection
        const currentAvatar = this.selectedAvatar;
        // Update observable properties - this will trigger the change handlers
        this.conversation = conversation;
        // If there's a current avatar selected, preserve it unless conversation explicitly has a different one
        if (currentAvatar && (!conversation || !((_a = conversation.model) === null || _a === void 0 ? void 0 : _a.avatar) || currentAvatar !== conversation.model.avatar)) {
            this.selectedAvatar = currentAvatar;
            if (ChatStateService.VERBOSE) {
                console.log('[ChatStateService] Preserved current avatar:', currentAvatar);
            }
        }
        else if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] Using conversation model avatar:', (_b = conversation.model) === null || _b === void 0 ? void 0 : _b.avatar);
        }
    }
    /**
     * Sync conversation model to currently selected model
     */
    syncToConversationModel() {
        if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] Syncing to conversation model:', this.conversation);
            console.log('[ChatStateService] Previous state - model:', this.selectedModel, 'provider:', this.selectedAIProvider, 'avatar:', this.selectedAvatar);
        }
        if (this.conversation) {
            this.selectedModel = this.conversation.model;
            this.selectedAIProvider = this.conversation.model.aiProvider || null;
            this.selectedAvatar = this.conversation.model.avatar || null;
            if (ChatStateService.VERBOSE) {
                console.log('[ChatStateService] New state - model:', this.selectedModel, 'provider:', this.selectedAIProvider, 'avatar:', this.selectedAvatar);
            }
        }
        else if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] No conversation model to sync to');
        }
    }
    /**
     * Check if conversation model differs from selected model
     */
    hasModelMismatch() {
        var _a;
        return false;
        if (!this.conversation || !this.conversation.model || !this.conversation.model.model || !this.selectedModel) {
            return false;
        }
        return this.conversation.model.model.value !== ((_a = this.selectedModel.model) === null || _a === void 0 ? void 0 : _a.value);
    }
    /**
     * Clear conversation data
     */
    clearConversation() {
        this.conversation = undefined;
        this.injectedMessages = [];
    }
    /**
     * Check if chat is visible based on current state
     */
    isChatVisible() {
        const hasBasicRequirements = this.selectedModel && this.selectedModel.model;
        if (!hasBasicRequirements) {
            return false;
        }
        // For inthub AI provider, avatar is required
        if (this.selectedAIProvider === 'inthub' && !this.selectedAvatar) {
            return false;
        }
        return true;
    }
    /**
     * Update web search and deep search settings
     */
    updateSearchSettings(webSearchEnabled, deepSearchEnabled) {
        this.webSearchEnabled = webSearchEnabled;
        this.deepSearchEnabled = deepSearchEnabled;
        if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] Updated search settings - webSearch:', webSearchEnabled, 'deepSearch:', deepSearchEnabled);
        }
    }
    /**
     * Set web search enabled state
     */
    setWebSearchEnabled(enabled) {
        this.webSearchEnabled = enabled;
        if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] Web search enabled set to:', enabled);
        }
    }
    /**
     * Set deep search enabled state
     */
    setDeepSearchEnabled(enabled) {
        this.deepSearchEnabled = enabled;
        if (ChatStateService.VERBOSE) {
            console.log('[ChatStateService] Deep search enabled set to:', enabled);
        }
    }
    /**
     * Reset state to defaults
     */
    reset() {
        this.conversation = undefined;
        this.selectedModel = null;
        this.selectedAIProvider = null;
        this.selectedAvatar = null;
        this.knowledge = [];
        this.fullKnowledgeIds = [];
        this.injectedMessages = [];
        this.webSearchEnabled = false;
        this.deepSearchEnabled = false;
    }
}
exports.ChatStateServiceInstance = ChatStateService;
ChatStateService.VERBOSE = false;
exports.default = ChatStateService.getSingleton();
